




















import {Component, Prop, Vue} from 'vue-property-decorator';
import {fetchCriteriaOptimizationList} from '@/api/journals/plan/edit/tables/PlanResSummaryListApi';

@Component
export default class PlanResSummaryList extends Vue {
    @Prop() params!: any;
    @Prop() tabData!: any;

    private loading: boolean = false;
    private data: any = null;

    get idPlanRes() {
        return this.tabData?.idPlanRes;
    }

    created() {
        this.getData();
    }

    async getData() {
        this.loading = true;
        try {
            const {data} = await fetchCriteriaOptimizationList(this.idPlanRes);
            this.data = data;
        } finally {
            this.loading = false;
        }
    }
}
